/* Re-keys resolved flag values by the flag each entry stands for, rather than by the caller's
 * own name for it.
 *
 * The hooks answer under the names a caller asked with — `{ mapEnabled: 'ALL_VISITS_MAP' }`
 * reads back as `enabled.mapEnabled` — which suits a component and does not suit telemetry: a
 * flag reported under a local field name cannot be found by its own name, and two callers
 * naming one flag differently report it as two.
 */
export const toEnabledByFlagName = (
    features: Record<string, string>,
    enabledByKey: Record<string, boolean>,
): Record<string, boolean> =>
    Object.keys(enabledByKey).reduce<Record<string, boolean>>((enabled, key) => {
        enabled[features[key]] = enabledByKey[key];
        return enabled;
    }, {});
